import { render, staticRenderFns } from "./Updates.vue?vue&type=template&id=6c00151e&"
import script from "./Updates.vue?vue&type=script&lang=js&"
export * from "./Updates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports